// Tells lifecycle email that a content's clips were seen, now or when the tab is next
// visible, so someone who watched them appear never gets "Your clips are still waiting".
import api from "@/service/api"

type GetToken = () => Promise<string | null>

const unseen = new Map<string, GetToken>()
let listening = false

function listenForVisibility() {
  if (listening) return
  listening = true
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState !== "visible") return
    for (const [contentId, getToken] of unseen) recordClipViewWhenSeen(contentId, getToken)
  })
}

export function recordClipViewWhenSeen(contentId: string, getToken: GetToken) {
  if (document.visibilityState !== "visible") {
    unseen.set(contentId, getToken)
    listenForVisibility()
    return
  }
  unseen.delete(contentId)
  void getToken()
    .then(token => api.messaging.recordClipView(contentId, token))
    .catch(() => {})
}
